export class UserAuthorizationViewModel {
    moduleId: number;
}






// WEBPACK FOOTER //
// ./src/app/domain/authorization/user-authorization.models.ts